import {FlowStatePresentation} from "@nolimit/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimit/slot-game/bin/flowcontrol/FlowStateController";
import {FireInTheHole2} from "../FireInTheHole2";
import {gsap} from "gsap";

export class FITH2NormalBetPresentation implements FlowStatePresentation {
    public start(flowStateController: FlowStateController) {
        const tl = gsap.timeline();
        FireInTheHole2.xBetController.featureEnabled = false;
        FireInTheHole2.xBetController.stopIdle();

        FireInTheHole2.logo.stopIdle();
        FireInTheHole2.multiplier.update(1);
        if(FireInTheHole2.model.isNextNormal){
            FireInTheHole2.reelTopBar.reset();
        }
        tl.add([
            () => {
                FireInTheHole2.reelBackground.onSpin();
            },
            FireInTheHole2.reelFrame.ways.hide(),
            FireInTheHole2.reelArea.dropOut()
        ]);
        tl.add(() => {
            flowStateController.finish()
        });
    }
}